import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { TwoColumnLayoutModule } from 'src/app/common-components/column-layouts/two-column-layout/two-column-layout.module';
import { DetailLinksModule } from 'src/app/common-components/detail-links/detail-links.module';
import { ResizeOnTabChangeDirectiveModule } from 'src/app/common-components/detail/resize-on-tab-change-directive.module';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { LcsSingleSelectModule } from 'src/app/common-components/entity-select/single-select/single-select.module';
import { FormFooterModule } from 'src/app/common-components/form-footer/form-footer.module';
import { UpdateDetailsModule } from 'src/app/common-components/update-details/update-details.module';
import { FormatPhoneNumbersPipeModule } from 'src/app/pipes/format-phone-numbers/format-phone-numbers-pipe.module';
import { LocationModule } from 'src/app/pipes/location/location.module';
import { ClosedExceptionsModule } from '../closed-exceptions/closed-exceptions.module';
import { CallCostDetailComponent } from './containers/call-cost-detail.component';
import { CallCostDetailEffects } from './state/call-cost-detail.effects';
import * as fromCallCostDetail from './state/call-cost-detail.reducer';
import { CallCostDetailViewComponent } from './views/call-cost-detail-view.component';
@NgModule({
   declarations: [CallCostDetailViewComponent, CallCostDetailComponent],
   exports: [CallCostDetailComponent],
   imports: [
      CommonModule,
      FormsModule,
      MatFormFieldModule,
      FormatPhoneNumbersPipeModule,
      ReactiveFormsModule,
      MatCheckboxModule,
      MatInputModule,
      MatIconModule,
      MatMenuModule,
      MatButtonModule,
      MatTooltipModule,
      LcsLoadingOverlayModule,
      LcsResponsiveTableModule,
      LcsCallStatePipeModule,
      TwoColumnLayoutModule,
      FormFooterModule,
      MatSelectModule,
      LocationModule,
      LcsSingleSelectModule,
      EntitySelectModule,
      MatTabsModule,
      RouterModule,
      DetailLinksModule,
      UpdateDetailsModule,
      ScrollingModule,
      MatDividerModule,
      CurrencyPipe,
      StoreModule.forFeature(fromCallCostDetail.callCostDetailFeatureKey, fromCallCostDetail.reducer),
      EffectsModule.forFeature([CallCostDetailEffects]),
      AppRoutingModule,
      UpdateDetailsModule,
      ClosedExceptionsModule,
      ResizeOnTabChangeDirectiveModule,
   ],
})
export class CallCostDetailModule {}
